"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_virtuoso_1 = require("react-virtuoso");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var context_1 = require("./context");
var window_1 = require("./hooks/window");
var spinner_1 = tslib_1.__importDefault(require("./components/spinner"));
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(", "px, 1fr));\n  grid-column-gap: 24px;\n  grid-row-gap: 24px;\n"], ["\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(", "px, 1fr));\n  grid-column-gap: 24px;\n  grid-row-gap: 24px;\n"])), function (props) { return (props === null || props === void 0 ? void 0 : props.width) || 250; });
var DataGrid = function (_a) {
    var _b;
    var quickFilters = _a.quickFilters, _c = _a.records, records = _c === void 0 ? [] : _c, loading = _a.loading, onPaginate = _a.onPaginate, hasMore = _a.hasMore, offsetTop = _a.offsetTop, render = _a.render, renderItemWidth = _a.renderItemWidth;
    var tableCtx = (0, context_1.useTableContext)();
    var height = (0, window_1.useWindowSize)().height;
    var tableHeight = height ? (((_b = tableCtx.filtersObject) === null || _b === void 0 ? void 0 : _b.isOpen) ? height - (offsetTop + 125) : height - offsetTop) : 500;
    if (quickFilters) {
        tableHeight = height ? height - offsetTop : 500;
    }
    var list = Container;
    list.defaultProps = { width: renderItemWidth };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_virtuoso_1.VirtuosoGrid, { style: { height: tableHeight }, totalCount: records.length, components: {
                List: list,
            }, itemContent: function (index) {
                if (render) {
                    return render(records[index]);
                }
                return react_1.default.createElement(react_1.default.Fragment, null, "-");
            }, endReached: function () {
                if (hasMore) {
                    onPaginate();
                }
            } }),
        loading && react_1.default.createElement(spinner_1.default, null)));
};
exports.default = DataGrid;
var templateObject_1;
//# sourceMappingURL=data-grid.js.map